import { render, staticRenderFns } from "./studentRemove.vue?vue&type=template&id=37942c98&scoped=true&"
import script from "./studentRemove.vue?vue&type=script&lang=ts&"
export * from "./studentRemove.vue?vue&type=script&lang=ts&"
import style0 from "./studentRemove.vue?vue&type=style&index=0&id=37942c98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37942c98",
  null
  
)

export default component.exports